<div class="carousel-window">
    <ul class="carousel-loader"
        [ngClass]="{'is-slider': !carouselType, 'has-unique-item': items?.length === 1}"
        (panmove)="panMoveAction($event)"
        (panstart)="panStartAction()"
        (panend)="panEndAction($event)">
        <ng-content></ng-content>
    </ul>
</div>
